import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { SearchResult } from '@/models/Repository'

const state = {
  loading: {
    search: false,
  },
  searchResult: new SearchResult(),
  agencyList: [],
  agencyAccountList: [],
  advertiserList: [],
  keyword: '',
  pageNo: 1,
  pageSize: 100,
  sortOptions: {
    sortBy: 'id',
    descending: true,
  },
}

const advertiser = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default advertiser
